// extracted by mini-css-extract-plugin
export default {"loader-wrapper":"Loader_loader-wrapper__G8FWl","loader":"Loader_loader__h1gM4","spin":"Loader_spin__OdSmp"};